import React, { Component } from 'react'
import T from '../../../../SPRINTA/translate/T'

import Modal from '../../../atoms-v2/Modal'
import Button from '../../../atoms/Button'
import AspectRatio from '../../../atoms/AspectRatio'
import ImageDropArea from '../../../molecules/ImageDropArea'
import SelectFileName from '../../../molecules/SelectFileName'
import { Textarea, Text } from '../../../atoms/Forms'
import Alert from '../../../atoms/Alert'
import Loading from '../../../atoms/Loading'
import ProgressBar from '../../../atoms/ProgressBar'

import { Col, Container, Row } from '../../../atoms/Grid'
import Font from '../../../atoms/Font'

import LoaderRounded from '../../../atoms/LoaderRounded'

import ActionBtnIcon from '../../../molecules/ActionBtnIcon'

import QuillEditor from '../../../third-party/QuillEditor'

import * as image from '../../../../libraries/Image'

import * as timeline from '../../../../utils/timeline'

import style from './style.css'
export default class Timeline extends Component {
    state = {
        modal: null,
        post: {
            value: '',
            status: '',
            message: ''
        },
        file: {
            name: '',
            value: '',
            status: '',
            message: '',
            progress: 0,
            file: ''
        },
        postImg: {
            value: '',
            status: '',
            message: '',
            imgsInProgress: 0,
            progress: 0,
        },
        images: [],
        imagesPreview: [],
        imagesLoading: [],
        article: {
            id: null,
            title: '',
            content: '',
            is_published: 0,
            status: 'done',
            message: ''
        },
        hasSendingImages: false,
        articleScrolled: false,
        modalConfirm: '',
        containerElementArticle: null
    }

    constructor(props) {
        super(props)
        this.handleAddImage = this.handleAddImage.bind(this)
    }


    editorHandleScroll(target) {
        if(target.scrollTop > 190) {
            document.querySelector('.ql-toolbar').style.position = 'fixed'
        } else {
            document.querySelector('.ql-toolbar').style.position = 'relative'
        }
    }

    handleGetArticle(id) {
        this.setState({
            article: {
                ...this.state.article,
                status: 'loading'
            }
        })

        if(id) {

            timeline.loadPost(id)
            .then(resp => {
                this.setState({
                    article: {
                        id: resp.id,
                        content: resp.long_content,
                        is_published: resp.status === '3' ? true : false,
                        title: JSON.parse(resp.content).title,
                        status: 'done',
                        autosaving: 'done'
                    }
                })
            })
        } else {
            timeline.getArticleStarted(this.props.tlid)
            .then(resp => {
                this.setState({
                    article: {
                        id: resp.id,
                        content: resp.long_content,
                        is_published: resp.status === 3 ? true : false,
                        title: JSON.parse(resp.content).title,
                        status: 'done',
                        autosaving: 'done'
                    }
                })
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.modal === 'article') {
            this.handleGetArticle(nextProps.modalData.id)
        }

        this.setState({
            modal: nextProps.modal
        })
    } 

    closeModal(modal) {
        if(this.state.modal === 'article' && this.state.article.autosaving === 'to-save') {
            this.setState({
                modalConfirm: 'closeArticle',
                article: {
                    ...this.state.article,
                    autosaving: 'done'
                }
            })
        } else {
            this.forceCloseModal()
        }

    }

    forceCloseModal() {
        this.setState({
            modal: null
        })
        this.props.handleClose()
    }

    onChange(element, key) {
        let data = this.state[key]
        data[element.name] = element.value
        this.setState({
            ...this.state,
            [key]: data
        })
    }

    handleAddImage(preview, file) {
        if(this.state.images.length < 5) {
            this.setState({
                ...this.state,
                images: [
                    ...this.state.images,
                    file
                ],
                imagesPreview: [
                    ...this.state.imagesPreview,
                    preview
                ]
            })
        }
    }

    handleImages(files) {
        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            if(image.isImage(file)) {
                image.preview(file, this.handleAddImage)
            }
        }        
    }

    handleRemoveImage(key) {
        let images = this.state.images
        let imagesPreview = this.state.imagesPreview
        images.splice(key, 1)
        imagesPreview.splice(key, 1)
        this.setState({
            ...this.state,
            images,
            imagesPreview
        })
    }

    postSimpleText(e) {
        e.preventDefault()
        if(this.state.post.value === "") {
            this.setState({
                ...this.state,
                post: {
                    value: '',
                    status: 'error',
                    message: T.text('fill_timeline_post_content')
                }
            })
        } else {
            this.setState({
                ...this.state,
                post: {
                    ...this.state.post,
                    status: 'loading'
                }
            })

            timeline.newPostText(this.props.tlid, this.state.post.value)
            .then(data => {
                if(data.errors) {
                    this.setState({
                        ...this.state,
                        post: {
                            ...this.state.post,
                            status: 'error',
                            message: data.errors[0].message
                        }
                    })
                } else {
                    this.setState({
                        ...this.state,
                        post: {
                            status: 'done',
                            value: '',
                            message: '',
                        }
                    })
                    this.closeModal('post')
                    this.props.handleNewPost(data)
                }
            })
        }
    }

    postFile(e) {
        e.preventDefault()
        let content = this.state.file.value
        let file = this.state.file.file

        if(this.state.file.file === "") {
            this.setState({
                ...this.state,
                file: {
                    ...this.state.file,
                    status: 'error',
                    message: T.text('fill_file')
                }
            })
            return false
        }

        if(this.state.file.value === "") {
            this.setState({
                ...this.state,
                file: {
                    ...this.state.file,
                    status: 'error',
                    message: T.text('fill_file_text')
                }
            })
            return false
        }


        this.setState(state => ({
            ...state,
            file: {
                ...state.file,                
                status: 'loading',
            }
        }))
        timeline.newPostFile(this.props.tlid, {content, file}, (progress) => {
            this.setState(state => ({
                ...state,
                file: {
                    ...state.file,
                    progress
                }
            }))
        })
        .then(resp => {
            if(!resp.errors) {
                this.setState(state => ({
                    ...state,
                    file: {
                        progress: 0,                
                        status: 'done',
                        name: '',
                        value: '',
                        message: '',
                        file: '',
                    }
                }))
                this.refs.selectFileName.reset()
                this.closeModal('file')
                this.props.handleNewPost(resp)
                
                
            } else {
                this.setState(state => ({
                    ...state,
                    file: {
                        ...state.file,            
                        status: 'error',
                        message: resp.errors[0].message
                    }
                }))
                
            }
        })
    }


    postImages(e) {
        e.preventDefault()
        if(this.state.images.length === 0) {
            this.setState({
                postImg: {
                    ...this.state.postImg,
                    status: 'error',
                    message: T.text('fill_timeline_select_image')
                }
            })
            return false
        }

        this.setState({
            postImg: {
                ...this.state.postImg,
                status: 'loading',
                imgsInProgress: this.state.images.length
            }
        })

        if(this.state.images.length > 1) {
            timeline.newPostImages(this.props.tlid, this.state.postImg.value)
            .then(resp => {
                this.state.images.forEach((item, key) => {
                    this.uploadImagePost(resp.id, key)
                }) 
            })


        } else {
            timeline.newPostImage(this.props.tlid,
                                    {
                                        content: this.state.postImg.value,
                                        file: this.state.images[0]
                                    }, progress => {
                                        this.setState(state => ({
                                            ...state,
                                            postImg: {
                                                ...state.postImg,
                                                progress
                                            }
                                        }))
                                    })
            .then(resp => {
                // console.log(resp)
                this.props.handleNewPost(resp)               
                
                this.setState({
                    postImg: {
                        ...this.state.postImg,
                        imgsInProgress: 0
                    }
                })
                this.verifyPostImageDone()
            })
        }
    }

    resetFormAndDoneImages() {
        this.setState({
            postImg: {
                ...this.state.postImg,
                status: 'done',
                imgsInProgress: 0,
                value: '',
                message: '',
                progress: 0
            },
            images: [],
            imagesPreview: [],
            imagesLoading: []
        }, () => {
            this.closeModal('image')
        })
    }

    verifyPostImageDone(post_id) {
        if(this.state.postImg.imgsInProgress > 0) return false 
        
        if(this.state.imagesLoading.length > 1) {
            timeline.activePost(post_id)
            .then(resp => {
                this.resetFormAndDoneImages()
                this.props.handleNewPost(resp)                                
            })
        } else {
            this.resetFormAndDoneImages()
        }

    }

    uploadImagePost(id, index) {
        let imagesLoading = this.state.imagesLoading
        imagesLoading[index] = '1'
        this.setState({
            imagesLoading
        })
        timeline.uploadImagePost(id,
            {
                order: index,
                file: this.state.images[index]
            }, progress => {
                imagesLoading[index] = progress
                this.setState({
                    imagesLoading
                })
            })
        .then(resp => {
            this.setState(state => ({
                postImg: {
                    ...state.postImg,
                    imgsInProgress: state.postImg.imgsInProgress - 1
                }
            }), () => {
                this.verifyPostImageDone(id)
            })
        })
    }

    handleUploadImage(img, file) {
        this.setState({
            hasSendingImages: true
        })

        img.style.opacity = '0.3'
        timeline.uploadImageArticle(this.state.article.id, file, progress => {
        })
        .then(resp => {
            img.src = `${resp.link}`
            img.removeAttribute('style')
            this.handleSaveArticle()

            this.setState({
                hasSendingImages: false
            })

        })
    }

    handleSaveArticle() {
        if(this.state.hasSendingImages) return

        this.setState({
            article: {
                ...this.state.article,
                autosaving: 'saving',
                status: 'done',
                message: '',
            }
        })

        timeline.saveArticle(this.state.article.id, this.state.article.title, this.state.article.content)
        .then(resp => {
            this.setState({
                article: {
                    ...this.state.article,
                    autosaving: 'saved'
                }
            })
        })
    }

    handleArticleEdited() {
        
        if(this.state.article.autosaving === 'done' || this.state.article.autosaving === 'saved') {  
            this.setState({
                article: {
                    ...this.state.article,
                    autosaving: 'to-save'
                }
            })
            
            setTimeout(function() {
                if(this.state.article.is_published) return
                if(this.state.article.autosaving === 'to-save') {
                    this.handleSaveArticle()
                }
            }.bind(this), 10000);
        }
    }

    handlePublish() {
       this.setState({
           modalConfirm: 'publishArticle'
       })        
    }

    publishArticle() {
        this.setState({
            article: {
                ...this.state.article,
                status: 'publishing'
            }
        })
        if(this.state.article.title === '') {
            this.setState({
                article:{
                    ...this.state.article,
                    status: 'error',
                    message: T.text('fill_title')
                }
            })
        } else if(this.state.article.content === '') {
            this.setState({
                article:{
                    ...this.state.article,
                    status: 'error',
                    message: T.text('fill_content')
                }
            })
        } else {
            timeline.publishArticle(this.state.article.id, this.state.article.title, this.state.article.content)
            .then(resp => {
                if(!resp.errors)
                this.forceCloseModal()
                this.props.handleNewPost(resp)                
            })
        }
    }

    render() {
        return (
            <div>
                <Modal
                    active={this.state.modal === 'post'}
                    handleClose={() => this.closeModal('post')}
                    style={{width:'680px'}}>
                    <form onSubmit={(e) => { this.postSimpleText(e) }}>
                        <h3 className={style.title}>{T.text('write_a_post')}</h3>
                        { this.state.post.status === 'error' && (
                            <Alert type='danger'> {this.state.post.message} </Alert>
                        )}
                        <div className={style.itemGroup}>
                            <Textarea
                                value={this.state.post.value || ''}
                                name='value'
                                handleChange={(e) => {
                                    this.onChange(e.target, 'post')
                                }}
                                style={{
                                        height: '120px',
                                        fontSize: this.state.post.value.length > 80 || this.state.post.value === ''  ? '16px' : '25px'
                                        }}
                                className={style.textareaEffect}
                                placeholder={T.txt('placeholder_timeline_post')}
                                disabled={this.state.post.status === 'loading'}
                            />
                        </div>
                        <div className={style.btnFooter}>
                            <Button color='orange' inline disabled={this.state.post.status === 'loading'}>
                                { this.state.post.status === 'loading' ? 
                                (
                                    <Loading color='#fff'/>
                                )
                                : T.text('publish') }
                            </Button>
                        </div>
                    </form>
                </Modal>

                <Modal
                    active={this.state.modal === 'image'}
                    handleClose={() => this.closeModal('image')}
                    style={{width:'680px'}}>
                    <form onSubmit={(e) => { this.postImages(e) }}>
                        <h3 className={style.title}>{T.text('add_images')}</h3>

                        { this.state.postImg.status === 'error' && (
                            <Alert type='danger'> {this.state.postImg.message} </Alert>
                        )}
                                    
                        <div className={style.itemGroup}>
                            {this.state.images.length > 0 ? (
                                <div className={style.imgPreview}>
                                    <img src={this.state.imagesPreview[0]} alt='Preview' />
                                </div>
                            ) : (
                                <ImageDropArea files={(files) => { this.handleImages(files) } }/>
                            )}
                        </div>

                        <div className={style.itemGroup}>
                            <Textarea
                                value={this.state.postImg.value || ''}
                                name='value'
                                handleChange={(e) => {
                                    this.onChange(e.target, 'postImg')
                                }}
                                placeholder={T.txt('add_label_images')}
                                disabled={this.state.postImg.status === 'loading'}
                            /> 
                        </div>
                        {this.state.images.length > 0 && (
                            <div className={style.imagePreviewList}>
                                {
                                    this.state.imagesPreview.map( (image, key) => (
                                        <div key={key} className={style.imagePreviewMin}>
                                            {this.state.postImg.status !== 'loading' && (
                                                <div className={style.deleteImage}>
                                                    <ActionBtnIcon icon='close' theme='rounded-orange' action={() => { this.handleRemoveImage(key) }}/>
                                                </div>
                                            )}
                                            <AspectRatio image={image}/>
                                            {this.state.imagesLoading[key] && (

                                                <div className={style.loaderImg}>
                                                    <LoaderRounded progress={this.state.imagesLoading[key]} stroke='6' size='40px' />
                                                </div>
                                            )}
                                        </div>
                                    ))
                                }

                                {this.state.images.length > 0 && this.state.images.length < 5 && this.state.postImg.status !== 'loading' && (
                                    <div className={style.addImage}>
                                        <label>
                                            <input className={style.imageUpload} type='file' onChange={(e) =>  {
                                                this.handleImages(e.target.files)
                                                e.target.value = ''
                                                }} multiple accept="image/*"/>
                                            <ActionBtnIcon icon='more' size={40} theme='rounded' action={() => {}}/>
                                        </label>
                                    </div>
                                )}
                            </div>
                        )}

                        {this.state.postImg.status === 'loading' && this.state.postImg.progress > 0 && (
                            <div className={style.itemGroup}>
                                <ProgressBar theme='orange' progress={this.state.postImg.progress} />
                            </div>
                        )}     

                        <div className={style.btnFooter}>
                            <Button color='orange' inline disabled={this.state.postImg.status === 'loading'}>
                                { this.state.postImg.status === 'loading' ? 
                                (
                                    <Loading color='#fff'/>
                                )
                                : T.text('publish') }
                            </Button>
                        </div>
                    </form>
                </Modal>

                <Modal
                    active={this.state.modal === 'attachment'}
                    handleClose={() => this.closeModal('attachment')}
                    style={{width:'680px'}}>
                    <form onSubmit={(e) => { this.postFile(e) }}>
                        <h3 className={style.title}>{T.text('send_a_file')}</h3>
                        { this.state.file.status === 'error' && (
                            <Alert type='danger'> {this.state.file.message} </Alert>
                        )}
                        <div className={style.itemGroup}>
                            <Textarea
                                value={this.state.file.value || ''}
                                name='value'
                                handleChange={(e) => {
                                    this.onChange(e.target, 'file')
                                }}
                                placeholder={T.txt('placeholder_describe_file')}
                                disabled={this.state.file.status === 'loading'}                                
                            /> 
                        </div>
                        
                        <div className={style.itemGroup}>
                            <SelectFileName
                                disabled={this.state.file.status === 'loading'}                            
                                ref='selectFileName'
                                file={(file) => {
                                    this.onChange({ name: 'file', value: file.file }, 'file')
                                    this.onChange({ name: 'name', value: file.name }, 'file')
                                } }/>
                        </div>

                        {this.state.file.status === 'loading' && (
                            <div className={style.itemGroup}>
                                <ProgressBar theme='orange' progress={this.state.file.progress} />
                            </div>
                        )}     

                        <div className={style.btnFooter}>
                            <Button color='orange' inline disabled={this.state.file.status === 'loading'}>
                                { this.state.file.status === 'loading' ? 
                                (
                                    <Loading color='#fff'/>
                                )
                                : T.txt('publish') }
                            </Button>
                        </div>
                    </form>
                </Modal>

                <Modal
                    active={this.state.modal === 'article'}
                    handleClose={() => this.closeModal('article')}
                    full
                    style={{width: '100%' }}
                    handleScroll={event => this.editorHandleScroll(event.target)}
                    >
                    {this.state.article.status === 'loading' ? (
                        <Loading />
                    ) : (
                        <Container>
                            <h3 className={style.title}>{T.text('write_article')}</h3>
                            <div className={style.itemGroup}>
                                <Text value={this.state.article.title} handleChange={(e) => {
                                    this.setState({
                                        article: {
                                            ...this.state.article,
                                            title: e.target.value
                                        }
                                    }, () => {
                                        this.handleArticleEdited()                                        
                                    })
                                }} placeholder={T.txt('placeholder_article_title')} style={{fontSize: '30px', fontWeight: '100'}} />
                            </div>
                            <div className={`${style.editor} ${this.state.articleScrolled ? style.active : ''}`}>
                                <QuillEditor
                                    value={this.state.article.content}
                                    onChange={(value) => {
                                        this.setState({
                                            article: {
                                                ...this.state.article,
                                                content: value
                                            }
                                        }, () => {
                                            this.handleArticleEdited()                                        
                                        })
                                    }}
                                    placeholder={T.txt('placeholder_article_content')}
                                    onUploadImage={ (img, file) => { this.handleUploadImage(img, file) }}/>
                            </div>
                            <Col style={{ marginTop: '30px' }}>
                                <Row>
                                    {this.state.article.status === 'error' && (
                                        <Alert type='danger'>{this.state.article.message}</Alert>
                                    )}

                                    <div style={{textAlign: 'right'}}>
                                        { this.state.article.status !== 'publishing' && (
                                            <Button
                                                disabled={
                                                    this.state.article.autosaving === 'saving'
                                                        || this.state.article.autosaving === 'saved'
                                                    }
                                                color='grey'
                                                inline
                                                onClick={() => this.handleSaveArticle() }>
                                                {this.state.article.autosaving === 'saving'
                                                ? T.text('saving')
                                                : this.state.article.autosaving === 'saved' ?
                                                T.text('saved') : T.text('save')}
                                            </Button>
                                        )}
                                        { !this.state.article.is_published && (
                                            <Button
                                                color='orange'
                                                style={{marginLeft: '15px'}}
                                                inline
                                                onClick={() => this.handlePublish() }
                                                disabled={this.state.article.status === 'publishing'}>
                                                {this.state.article.status === 'publishing' ? (<Loading color='#fff' />) : T.text('publish') }
                                            </Button>
                                        )}

                                    </div>
                                </Row>
                            </Col>
                        </Container>
                    )}
                    
                </Modal>

                <Modal active={this.state.modalConfirm === 'publishArticle'}>
                    <div style={{textAlign: 'center'}}>
                        <Col>
                            <p><Font size={30} color='#4a4a4a' weight='100'>{T.text('confirmation')}</Font></p>
                            <p><Font color='#4a4a4a'>{T.text('confirmation_publish_article')}</Font></p>
                        </Col>
                        <Col style={{ marginTop: '20px' }}>
                            <Col size={6}>
                                <Button color='transparent-grey' onClick={() => { this.setState({
                                    modalConfirm: null
                                }) }}>{T.text('cancel')}</Button>
                            </Col>
                            <Col size={6}>
                                <Button
                                    color='red'
                                    disabled={this.state.deletingQuestion}
                                    onClick={() => {
                                            this.setState({
                                                modalConfirm: null
                                            })
                                            this.publishArticle()
                                        }}>
                                    {T.text('publish')}
                                </Button>
                            </Col>
                        </Col>
                    </div>
                </Modal>


                <Modal active={this.state.modalConfirm === 'closeArticle'}>
                    <div style={{textAlign: 'center'}}>
                        <Col>
                            <p><Font size={30} color='#4a4a4a' weight='100'>{T.text('confirmation')}</Font></p>
                            <p><Font color='#4a4a4a'>{T.text('confirmation_changed_not_saved')}</Font></p>
                        </Col>
                        <Col style={{ marginTop: '20px' }}>
                            <Col size={6}>
                                <Button onClick={() => { this.setState({
                                    modalConfirm: null
                                }) }}>{T.text('back')}</Button>
                            </Col>
                            <Col size={6}>
                                <Button
                                    color='red'
                                    onClick={() => {
                                        this.forceCloseModal()
                                        this.setState({
                                            modalConfirm: null
                                        })
                                    }}>
                                    {T.text('confirm')}
                                </Button>
                            </Col>
                        </Col>
                    </div>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/organisms/Timeline/Modais/index.js